import _ from 'lodash';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { DefaultButton } from './DefaultButton.jsx';
import { alert, danger, dot, poiOne, poiTwo, poiThree } from './icons.jsx'

const IconBox = styled.span`
  width: 1.25em;
  min-width: 1.25em;
  margin-right: .5rem;

  @media (max-width: 500px) {
    margin-right: .25rem;
  }
`

const StyledRow = styled.div`
  margin: .5rem 0;
  line-height: 1.2em;
  padding: 0 .75em;

  h4 {
    text-decoration: underline;
  }

  @media (max-width: 500px) {
    h4 {
      margin: 0;
    }
    padding: 0 .5em;
  }
`

const Entry = styled(StyledRow)`
  display: flex;
`

const ClickRow = styled(DefaultButton)`
  margin: .5rem 0;
  line-height: 1.2em;
  padding: 0 .75em;
  text-align: left;

  h4 {
    text-decoration: underline;
  }

  @media (max-width: 500px) {
    h4 {
      margin: 0;
    }
    padding: 0 .5em;
  }
`

const ClickPoi = styled(ClickRow)`
  display: flex;
`

const ColumnBox = styled.div`
  display: block;
`

const flicker = keyframes`
  0% { opacity: 40 }
  10% { filter: blur(0px) }
  66% { transform: skewX(1deg) invert(-25%) }
  80% { filter: blur(.2px) invert(15%)  }
  96% { transform: skewX(-1deg) }
`

const HiddenEntry = styled(Entry)`
  overflow: none;
`

const Barcode = styled.div`
  margin: .2rem;
  font-family: 'Libre Barcode 39', cursive;
  line-height: 1em;
  font-size: 1.5rem;
  animation: ${flicker} 1s ease-in-out alternate infinite;
`

const Danger = styled(danger)`
  fill: ${(props) => props.theme.primaryColor};
  stroke: ${(props) => props.theme.primaryColor};
  stroke-width: 8px;
`

const Alert = styled(alert)`
  fill: ${(props) => props.theme.primaryColor};
  stroke: ${(props) => props.theme.primaryColor};
  stroke-width: 5px;
`

const Dot = styled(dot)`
  stroke: ${(props) => props.theme.primaryColor};
  fill: none;
  stroke-width: 20px;
`

const One = styled(poiOne)`
  fill: ${(props) => props.theme.primaryColor};
  width: 100%;
`

const Two = styled(poiTwo)`
  fill: ${(props) => props.theme.primaryColor};
  width: 100%;
`

const Three = styled(poiThree)`
  fill: ${(props) => props.theme.primaryColor};
  width: 100%;
`

export const DataRow = ({data, reroll, type}) => {
  return (
    <ClickPoi onClick={() => reroll(type)}>
      <IconBox>
        {data.icon === 'danger' && <Danger />}
        {data.icon === 'alert' && <Alert />}
        {!data.icon && <Dot />}
      </IconBox>
      <ColumnBox>
        <h4>{`${_.toUpper(data.description)}`}</h4>
        {data.alert_text &&
          <p>{` ${_.capitalize(data.alert_text)}`}</p>
        }
      </ColumnBox>
    </ClickPoi>
  )
}

export const HiddenRow = ({text}) => {
  return (
    <HiddenEntry>
      <Barcode>{text}</Barcode>
    </HiddenEntry>
  )
}

export const PoiRow = ({poi, number, wardenView, reroll}) => {
  return (
    <ClickPoi onClick={() => reroll(number)}>
      <IconBox>
        {(() => {
          switch(number) {
            case 'one': return( <One />)
            case 'two': return <Two />
            case 'three': return <Three />
            default: return
          }
        })()}
      </IconBox>
      <ColumnBox>
        <h4>{`${_.toUpper(poi.description)}`}</h4>
        {wardenView && <p>{`${poi.text}`}</p>}
      </ColumnBox>
    </ClickPoi>
  )
}

export const WardenRow = ({type, description, reroll}) => {
  return (
    <ClickRow onClick={() => reroll(type)}>
      <h4>{type}</h4>
      <p>{description}</p>
    </ClickRow>
  )
}

export const TypeRow = ({gaseous})=> {
  return (
    <Entry>
      <IconBox>
        <Dot />
      </IconBox>
      <h4>{gaseous ? 'GASEOUS' : 'TERRESTRIAL'}</h4>
    </Entry>
  )
}
